import moment from 'moment';

const excludedData = '0001-01-01T00:00:00Z';

export const getReadableDate = (date?: string | Date, format: string = 'DD/MM/YYYY'): string => {
  if (!date) return '';
  if (date === excludedData) return '-';
  return moment(date).format(format);
};
